export default {"src":"/_next/static/media/ZAR.45e556b6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};